<div class="page-comment-section">
  <mat-form-field appearance="outline">
    <!-- <mat-icon matPrefix>info_outline</mat-icon> -->
    <img matPrefix class="info-icon" src="../../assets/images/info-icon.png" />
    <textarea matInput rows="1" [(ngModel)]="pageComment" (blur)="focusOutFunction($event)"></textarea>
  </mat-form-field>
</div>
